<template>
  <div>
    <hr class="top" />
    <!-- <el-button plain style="margin-left: 3%"
      ><a
        :href="[
          '//127.0.0.1:8000/download?type=csv&params=' +
            this.$route.query['rank'],
        ]"
        >CSV</a
      ></el-button
    >
    <el-button plain
      ><a
        :href="[
          '//127.0.0.1:8000/download?type=xls&params=' +
            this.$route.query['rank'],
        ]"
        >Excel</a
      ></el-button
    >
    <el-button plain
      ><a
        :href="[
          '//127.0.0.1:8000/download?type=txt&params=' +
            this.$route.query['rank'],
        ]"
        >TXT</a
      ></el-button
    > -->
    <div style="text-align: right; margin-right: 10%">
      Search :<el-input v-model="search_val"></el-input>
    </div>
    <el-table :data="datalist" border stripe>
      <el-table-column
        type="index"
        :index="(page - 1) * page_size + 1"
        :resizable="false"
        label="#"
        width="60px"
      ></el-table-column>
      <el-table-column label="Strcture" prop="instance">
          <template slot-scope="scope">
            <a
              :href="['@/../#/mol/?pdb='+val(scope.row.instance)]"
              style="text-decoration:none;"
            >{{scope.row.instance}}</a>
          </template>
        </el-table-column>
       <el-table-column label="Sequence" prop="accession">
          <template slot-scope="scope">
            <a
              :href="['@/../#/content/?accession='+val(scope.row.uniprot)]"
              style="text-decoration:none;"
            >{{scope.row.uniprot}}</a>
          </template>
        </el-table-column>
      <el-table-column label="Instance" prop="instance">
        <template slot-scope="scope">
          <a
            :href="[
              'http://www1.rcsb.org/sequence/' +
                scope.row.code +
                '#' +
                scope.row.chain,
            ]"
            style="text-decoration: none"
            >{{ scope.row.instance }}</a
          >
        </template>
      </el-table-column>
      <el-table-column label="PDB Code" prop="code">
        <template slot-scope="scope">
          <a
            :href="[
              'https://www.ebi.ac.uk/pdbe/entry/pdb/' + scope.row.code,
            ]"
            style="text-decoration: none"
            >{{ scope.row.code }}</a
          >
        </template>
      </el-table-column>
      <el-table-column label="Cofactor(s)" prop="symbol">
           <template slot-scope="scope">
            <el-button v-for="item in symbol(scope.row.symbol)" :key="item.id" type="primary" plain>{{item}}</el-button>
          </template></el-table-column>


          <el-table-column label="CMM Tag" prop="cmm">
           <template slot-scope="scope">
            <el-button v-if="scope.row.cmm==1" icon="el-icon-check"></el-button>
            <el-button v-else icon="el-icon-close"></el-button>
          </template></el-table-column>
      <el-table-column label="CMM link"><a href="https://cmm.minorlab.org/" style="text-decoration: none"><i class="el-icon-link"></i></a></el-table-column>
      <el-table-column label="Pfam" prop="pfam">
        <template slot-scope="scope">
          <a
            :href="['http://pfam.xfam.org/family/' + val(scope.row.pfam)]"
            style="text-decoration: none"
            >{{ scope.row.pfam }}</a
          >
        </template>
      </el-table-column>
      <el-table-column label="CATH" prop="cath">
        <template slot-scope="scope">
          <a
            :href="[
              'http://www.cathdb.info/version/v4_3_0/superfamily/' +
                val(scope.row.cath),
            ]"
            style="text-decoration: none"
            >{{ scope.row.cath }}</a
          >
        </template>
      </el-table-column>
      <el-table-column label="SCOP" prop="scop">
        <template slot-scope="scope">
          <a
            :href="[
              'https://scop.mrc-lmb.cam.ac.uk/scop/search.cgi?sccs=' +
                val(scope.row.scop),
            ]"
            style="text-decoration: none"
            >{{ scope.row.scop }}</a
          >
        </template>
      </el-table-column>
      <el-table-column label="View" prop="instance">
          <template slot-scope="scope">
            <a :href="['@/../#/mol/?id='+scope.row.instance]" target="_blank" style="text-decoration:none;">
            <el-button type="primary" icon="el-icon-thumb" plain>Click</el-button></a>
          </template>
        </el-table-column>
    </el-table>
    <hr />
    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <hr />
  </div>
</template>

<script>
export default {
  //data
  data() {
    return {
      total: null,
      datalist: [],
      page_size: 10,
      page: 1,
      search_val: "",
    };
  },
  //钩子函数
  created() {
    this.getData();
  },

  //methods
  methods: {
    async getData() {
      const res = await this.$http.get("pdb" + "/", {
        params: {
          page: this.page,
          page_size: this.page_size,
        },
      });
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      this.datalist = res.data.results;
      this.total = res.data.count;
    }, //
    async SearchData() {
      const res = await this.$http.get("pdbsearch" + "/", {
        params: {
          page: this.page,
          page_size: this.page_size,
          word: this.search_val,
        },
      });
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      this.datalist = res.data.results;
      this.total = res.data.count;
    },

    //监听每页显示变化
    handleSizeChange(newPage_size) {
      this.page_size = newPage_size;
      this.getData();
    },
    //处理后端字符串
    val(str) {
      if (typeof str == "undefined" || str == null || str == "") {
        var arr = "";
      } else {
        var arr = str.split("|")[0];
      }
      return arr;
    },
    symbol(str){
    var res = eval(str);
     return res;
   },


    //监听当前页变化
    handleCurrentChange(newPage) {
      this.page = newPage;
      this.getData();
    },
  },
  //
  watch: {
    $route(to, from) {
      this.getData();
    },
    search: function () {
      this.SearchData();
    },
    //
    search_val: function () {
      // 实现input连续输入，只发一次请求
      this.loading_show = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.SearchData();
      }, 300);
    },
    //
  },
};
</script>

<style  lang="less" scoped>

.el-form-item {
  width: 300px;
  margin: 0;
  /deep/ .el-form-item__label {
    width: 100px;
  }
  /deep/.el-form-item__content {
    width: 200px;
  }
}
.el-pagination {
  display: flex;
  justify-content: center;
}
.el-table {
  /deep/ th {
    background-color: #adc3ce;
    color: rgb(8, 0, 0);
    font-size: 1.3em;
    text-align: center;
  }
  /deep/ td {
    text-align: center;
  }
}
.top {
  margin-top: 40px;
}
button {
  a {
    font-size: 13px;
    text-decoration: none;
    color: black;
  }
  a:hover {
    color: rgb(11, 68, 153);
  }
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input {
  display: inline-block;
  width: 150px;
  height: 45px;
  padding-left: 20px;
}
</style>